// Modules
import { useCallback, useContext } from 'react'

// Context
import Data from 'context/Data'
import Dispatch from 'context/Dispatch'

// Reducers
import { SYSTEM_ACTIONS } from 'reducers/system'

// Constants
import { THEMES } from 'constants/options'

// Hook: System > Theme
function useTheme () {
	// Data
	const { theme } = useContext(Data)
	const dispatch = useContext(Dispatch)

	// Functions (Memoized)
	const setTheme = useCallback(theme => dispatch({ type: SYSTEM_ACTIONS.CHANGE_THEME, payload: theme }), [dispatch])
	const toggleTheme = useCallback(() => {
		dispatch({ type: SYSTEM_ACTIONS.CHANGE_THEME, payload: THEMES.find(themeOption => themeOption !== theme) })
		window.dataLayer.push({ event: 'system-theme-change' })
	}, [theme, dispatch])

	// Response
	return { setTheme, theme, toggleTheme }
}

// Export
export default useTheme
